/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const scheduleArchiveBodyExpectedVersionExclusiveMin = 0;
export const scheduleArchiveBodyExpectedVersionMax = 9007199254740991;

export const scheduleArchiveBodyPreviewFingerprintMax = 256;

export const ScheduleArchiveBody = zod.object({
  expectedVersion: zod
    .int()
    .gt(scheduleArchiveBodyExpectedVersionExclusiveMin)
    .max(scheduleArchiveBodyExpectedVersionMax),
  previewFingerprint: zod.string().min(1).max(scheduleArchiveBodyPreviewFingerprintMax),
  confirmed: zod.literal(true),
});

export type ScheduleArchiveBody = zod.input<typeof ScheduleArchiveBody>;
export type ScheduleArchiveBodyOutput = zod.output<typeof ScheduleArchiveBody>;
